{
  "name": "app",
  "version": "1.3.0",
  "description": "Rumyk an application",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host=0.0.0.0 --disable-host-check --configuration development",
    "prod": "ng serve --configuration production",
    "build": "ng build --configuration development",
    "build-dev": "ng build --configuration dev",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --no-watch --no-progress --browsers=ChromeHeadless --code-coverage",
    "lint": "ng lint",
    "release:major": "npm version major",
    "release:minor": "npm version minor",
    "release:patch": "npm version patch"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.1.7",
    "@angular/cdk": "^20.1.6",
    "@angular/common": "^20.1.7",
    "@angular/compiler": "^20.1.7",
    "@angular/core": "^20.1.7",
    "@angular/forms": "^20.1.7",
    "@angular/material": "^20.2.0",
    "@angular/platform-browser": "^20.1.7",
    "@angular/platform-browser-dynamic": "^20.1.7",
    "@angular/router": "^20.1.7",
    "@datadog/browser-rum": "^6.30.1",
    "eslint-formatter-checkstyle": "^8.40.0",
    "eslint-plugin-prettier": "^5.5.4",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.1.6",
    "@angular/cli": "^20.1.6",
    "@angular/compiler-cli": "^20.1.7",
    "@types/jasmine": "~5.1.9",
    "angular-eslint": "20.1.1",
    "eslint": "^9.33.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.8.2",
    "typescript-eslint": "8.39.1"
  }
}
